import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../../components/user/sector/sectorForm';
import Layout from '../../../components/layouts/verticalLayout';
import { useParams } from 'react-router-dom';

const SectorFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Form uuid={uuid} />} />;
};

SectorFormPage.propTypes = {};

export default SectorFormPage;
